/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { FilePlus2 } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';
const NS = '/bff/v1/j10-s01-solicitante-protocolar-pedido';
export function ProtocolarSolicitacaoPage() {
  const [e, setE] = useState<any>();
  const [descricao, setD] = useState(
    'Solicito alteração formal da ordem de serviço, preservando o registro vigente até decisão competente.',
  );
  const [ocupado, setO] = useState(false);
  async function call(path: string, corpo?: unknown) {
    setO(true);
    try {
      const r = await chamarApi<any>(NS + path, {
        metodo: path === '/state' ? 'GET' : 'POST',
        corpo,
      });
      setE(r.state);
    } finally {
      setO(false);
    }
  }
  useEffect(() => {
    void call('/state');
  }, []);
  if (!e) return <p role="status">Carregando solicitação…</p>;
  const tipo = e.tipos[0],
    obj = e.objetos[0],
    draft = e.rascunhos[0];
  return (
    <main className="w-full min-w-0 space-y-5 overflow-x-hidden">
      <h1 className="text-3xl font-semibold">
        <FilePlus2 className="mr-2 inline" />
        {e.titulo}
      </h1>
      <p>{e.descricao}</p>
      {e.alertas.map((a: any) => (
        <p role="alert" key={a.codigo}>
          {a.mensagem} <code>{a.codigo}</code>
        </p>
      ))}
      {tipo && obj && !draft && (
        <section className="space-y-3 rounded-md border p-4">
          <p>
            Tipo: <strong>{tipo.nome}</strong>
          </p>
          <p>
            Objeto oficial: OS {obj.numero} · {obj.status}
          </p>
          <label>
            Descrição
            <textarea
              aria-label="Descrição do pedido"
              className="block min-h-28 w-full rounded-md border bg-background p-2"
              value={descricao}
              onChange={(x) => setD(x.target.value)}
            />
          </label>
          <Button
            disabled={ocupado || descricao.length < 20}
            onClick={() =>
              void call('/verbs/salvar_rascunho', {
                tipoId: tipo.id,
                objetoTipo: tipo.objeto_tipo,
                objetoId: obj.id,
                descricao,
              })
            }
          >
            Salvar rascunho
          </Button>
        </section>
      )}
      {draft && (
        <article className="space-y-3 rounded-md border p-4">
          <h2 className="font-semibold">Rascunho v{draft.versao}</h2>
          <p>{draft.descricao}</p>
          <p>{draft.anexos.length} comprovante(s)</p>
          {!draft.anexos.length && (
            <Button
              disabled={ocupado}
              onClick={() =>
                void call('/verbs/anexar_comprovante', {
                  rascunhoId: draft.id,
                  nome: 'comprovante-alteracao.txt',
                  mimeType: 'text/plain',
                  conteudoBase64: btoa('Comprovante real da solicitação ' + draft.id),
                  chaveIdempotencia: crypto.randomUUID(),
                })
              }
            >
              Anexar comprovante
            </Button>
          )}
          <Button
            disabled={ocupado || !draft.anexos.length}
            onClick={() =>
              void call('/verbs/protocolar_pedido', {
                rascunhoId: draft.id,
                chaveIdempotencia: crypto.randomUUID(),
              })
            }
          >
            Protocolar pedido
          </Button>
        </article>
      )}
      <section className="space-y-2">
        {e.pedidos.map((p: any) => (
          <article className="rounded-md border p-4" key={p.id}>
            <h2 className="font-semibold">
              {p.protocolo} · {p.status}
            </h2>
            <p>
              {p.tipo_nome} · {p.unidade_destino} · {p.fila} · {p.alcada}
            </p>
            <p>Prazo: {p.prazo_decisao_em}</p>
            <code className="break-all">{p.id}</code>
          </article>
        ))}
      </section>
      {e.resultado && <p role="status">Operação persistida: {JSON.stringify(e.resultado)}</p>}
    </main>
  );
}
